import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfiguration } from 'src/app/app.configuration';
import { Observable, BehaviorSubject, throwError, of } from 'rxjs';
import {
  map,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  shareReplay,
  tap,
  catchError,
} from 'rxjs/operators';
import { AlbaranService } from 'src/app/modules/gestionar-venta/services/albaran.service';
import { ConfigurationService, TurnoService } from 'src/app/core';
import { AmigosThyssenService } from 'src/app/modules/amigos-thyssen/services/amigos-thyssen.service';
import { TranslateService } from './translate.service';
import { SuccessToast } from 'src/app/core/toast/success.toast';
import { ToastrService } from 'ngx-toastr';
import { TokenManagerService } from 'src/app/core/auth/token-manager.service';

@Injectable({
  providedIn: 'root',
})
export class FacturaService {
  private clienteSeleccionadoSubject: BehaviorSubject<any>;
  public clienteSeleccionado: Observable<any>;
  private listaClientes: any;
  private ultimaActualizacionClientes: any;
  private textoBuscadorSubject: BehaviorSubject<any>;
  public textoBuscador: Observable<any>;
  window = window as any;
  idioma = 'es-ES';

  constructor(
    private http: HttpClient,
    private config: AppConfiguration,
    private albaranService: AlbaranService,
    private configurationService: ConfigurationService,
    private turnoService: TurnoService,
    private translateService: TranslateService,
    private toastrService: ToastrService,
    private tokenManager: TokenManagerService,
    private amigosThyssenService: AmigosThyssenService
  ) {
    this.clienteSeleccionadoSubject = new BehaviorSubject(undefined);
    this.clienteSeleccionado = this.clienteSeleccionadoSubject.asObservable();
    this.textoBuscadorSubject = new BehaviorSubject(undefined);
    this.textoBuscador = this.textoBuscadorSubject.asObservable();
  }

  public get clienteSeleccionadoValue() {
    return this.clienteSeleccionadoSubject.value;
  }

  setClienteSeleccionadoValue(cliente) {
    // Asegurar que siempre se incluyan los campos necesarios para la inserción de venta
    /*let clienteCompleto = cliente;
    console.log('cliente', cliente);
    if (typeof cliente === 'string' || !cliente) {
      // Si es un string vacío o null/undefined, crear objeto por defecto
      clienteCompleto = { 
        Codigo: '0',
        FP_Id: '1', // Forma de pago por defecto
        FP_Facturar: '0', // No generar factura por defecto
        ConDescuento: 'False', // Sin descuento por defecto
        Dto: '0' // Descuento 0 por defecto
      };
    } else if (typeof cliente === 'object') {
      // Si es un objeto, asegurar que tenga los campos necesarios
      clienteCompleto = {
        Codigo: cliente.Codigo || '0',
        FP_Id: cliente.FP_Id || '1', // Forma de pago por defecto
        FP_Facturar: cliente.FP_Facturar || '0', // No generar factura por defecto
        ConDescuento: cliente.ConDescuento || 'False', // Sin descuento por defecto
        Dto: cliente.Dto || '0', // Descuento 0 por defecto
        // Preservar otros campos si existen
        ...cliente
      };
    }*/
    
    this.clienteSeleccionadoSubject.next(cliente);
  }
  public get textoBuscadorValue() {
    return this.textoBuscadorSubject.value;
  }

  settextoBuscadorValue(texto) {
    this.textoBuscadorSubject.next(texto);
  }

  crearFactura(datosFactura) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      CIFCliente: datosFactura.codigoLegal,
      NombreCliente: datosFactura.nombre,
      DomicilioCliente: datosFactura.direccion,
      LocalidadCliente: datosFactura.ciudad,
      CPCliente: datosFactura.codigoPostal,
      Provincia: datosFactura.provincia,
      Pais: datosFactura.pais,
      Comentarios: datosFactura.comentarios,
      Ventas: this.albaranService.albaranValue.NumVenta,
      GuardarInfo: '0',
      idContacto: '0',
      ClienteCodigo: (() => {
        const amigoActivo = this.amigosThyssenService.getAmigoActivo();
        const clienteCodigo = amigoActivo
          ? '0' // Forzar 0 cuando viene de AMIGOS THYSSEN
          : datosFactura.codigoCliente;
        
        console.log('🧾 [FACTURA SERVICE] ClienteCodigo para GenerarFactura (normal):');
        console.log('🧾 [FACTURA SERVICE] amigoActivo:', amigoActivo);
        console.log('🧾 [FACTURA SERVICE] datosFactura.codigoCliente:', datosFactura.codigoCliente);
        console.log('🧾 [FACTURA SERVICE] clienteCodigo final:', clienteCodigo);
        
        return clienteCodigo;
      })(),
      UserName: JSON.parse(localStorage.getItem('currentUser')),
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GenerarFactura`, body)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  crearFacturaSimplificada(
    datosFactura,
    simplificada = null,
    clienteEspecificado = false
  ) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      CIFCliente:
        simplificada && !clienteEspecificado ? '' : datosFactura.codigoLegal,
      NombreCliente:
        simplificada && !clienteEspecificado ? '' : datosFactura.nombre,
      DomicilioCliente:
        simplificada && !clienteEspecificado ? '' : datosFactura.direccion,
      LocalidadCliente:
        simplificada && !clienteEspecificado ? '' : datosFactura.ciudad,
      CPCliente:
        simplificada && !clienteEspecificado ? '' : datosFactura.codigoPostal,
      Provincia:
        simplificada && !clienteEspecificado ? '' : datosFactura.provincia,
      Pais: simplificada && !clienteEspecificado ? '' : datosFactura.pais,
      Comentarios:
        simplificada && !clienteEspecificado ? '' : datosFactura.comentarios,
      Ventas: this.albaranService.albaranValue.NumVenta,
      GuardarInfo: '0',
      idContacto: '0',
      ClienteCodigo: (() => {
        const amigoActivo = this.amigosThyssenService.getAmigoActivo();
        const clienteCodigo = amigoActivo
          ? '0' // Forzar 0 cuando viene de AMIGOS THYSSEN
          : simplificada && !clienteEspecificado ? '' : datosFactura.codigoCliente;
        
        console.log('🧾 [FACTURA SERVICE] ClienteCodigo para GenerarFactura:');
        console.log('🧾 [FACTURA SERVICE] amigoActivo:', amigoActivo);
        console.log('🧾 [FACTURA SERVICE] simplificada:', simplificada);
        console.log('🧾 [FACTURA SERVICE] clienteEspecificado:', clienteEspecificado);
        console.log('🧾 [FACTURA SERVICE] datosFactura.codigoCliente:', datosFactura.codigoCliente);
        console.log('🧾 [FACTURA SERVICE] clienteCodigo final:', clienteCodigo);
        
        return clienteCodigo;
      })(),
      UserName: JSON.parse(localStorage.getItem('currentUser')),
      Simplificada: simplificada,
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GenerarFactura`, body)
      .pipe(
        map((res: any) => {
          if (res && res.DatosResult === null) {
            this.toastrService.success(
              this.translateService.instant(res.Mensajes),
              '',
              {
                toastComponent: SuccessToast,
              }
            );
            throw new Error();
          }
          return res;
        }),
        catchError((error) => {
          return of({
            DatosResult: null,
            Mensajes:
              error.message || 'Error desconocido al generar la factura.',
          });
        })
      );
  }

  recuperarFactura(datosFactura) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      LetraFactura: datosFactura.SerieFactura,
      NumFactura: datosFactura.NumFacturaId,
    };
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/RecuperarFacturaReferencias`,
        body
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  /*   pdfFactura(datosFactura) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      LetraFactura: datosFactura.FraSerie,
      NumFactura: datosFactura.FraNumero
    };
    return this.http.post(`${this.config.getConfig('API_URL')}api/FacturaPDF`, body).pipe(
      map((res: any) => {
        return res;
      })
    );
  } */

  pdfFactura(datosFactura) {
    //
    let body = {};
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    if ('FraNumero' in datosFactura) {
      body = {
        ConexionIacpos: conexionId,
        LetraFactura: datosFactura.FraSerie,
        NumFactura: datosFactura.FraNumero,
      };
    } else if ('NumFacVenta' in datosFactura) {
      body = {
        ConexionIacpos: conexionId,
        LetraFactura: datosFactura.SerieVenta,
        NumFactura: datosFactura.NumFacVenta,
      };
    } else if ('FacturaNumero' in datosFactura) {
      body = {
        ConexionIacpos: conexionId,
        LetraFactura: datosFactura.FacturaSerie,
        NumFactura: datosFactura.FacturaNumero,
      };
    } else {
      body = {
        ConexionIacpos: conexionId,
        LetraFactura: datosFactura.SerieFactura,
        NumFactura: datosFactura.NumFacturaId,
      };
    }
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/RecuperarFactura`, body)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  impresionFactura(datosFactura: any, mails?: string) {
    const currentToken = this.tokenManager.getTaquillaToken();
    if (!currentToken || !currentToken) {
      return throwError('No hay token de sesión disponible');
    }

    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const idioma = this.translateService.getLocale();
    const idiomaParam = `idioma=${idioma}`;
    const usuarioId = `usuarioId=${this.turnoService.turnoValue.UsuarioId}`;
    const tpvIdParam = `tpvId=${this.turnoService.turnoValue.TpvId}`;
    const { letraFactura, numFactura, factura, lfactura } =
      this.asignarFactura(datosFactura);
    const headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
      Authorization: `Bearer ${currentToken}`,
      'IAC-Connection-String': this.config.getConfig('chClaveEmpresa'),
    };

    let url = `${this.config.getConfig(
      'API_URL_TAQUILLA'
    )}/api/Factura/GenerarPDF?conexionId=${conexionId}&${idiomaParam}&${tpvIdParam}&${usuarioId}&${letraFactura}&${numFactura}`;

    if (mails) {
      url += `&envioEMail=1&${mails}`;
    }
    return this.http
      .get(url, { headers: headers, responseType: 'json' })
      .pipe(
        map((response: { datos: string; emailEnviado: number }) => {
          return response;
        }),
        tap((pdfBase64) => {
          if (!mails) {
            this.printPDFTarjeta(
              pdfBase64.datos,
              `${lfactura} - ${factura}`
            );
          }
        }),
        catchError((error) => {
          const statusMatch = error.match(/Error:\s(\d+)/);
          const statusCode = statusMatch
            ? parseInt(statusMatch[1], 10)
            : null;

          // Crear un nuevo error con el código de estado y el mensaje original
          const customError = {
            status: statusCode,
            message: error.message,
          };
          // Puedes devolver un valor por defecto o lanzar una excepción
          // return throwError(customError);
          return of(null);
        })
      );
  }

  asignarFactura(datosFactura): {
    letraFactura: any;
    numFactura: any;
    factura: any;
    lfactura: any;
  } {
    let letraFactura, numFactura, factura, lfactura;
    if ('FraNumero' in datosFactura) {
      letraFactura = `letrafactura=${datosFactura.FraSerie}`;
      numFactura = `numFactura=${datosFactura.FraNumero}`;
      factura = datosFactura.FraNumero;
      lfactura = datosFactura.FraSerie;
    } else if ('NumFacVenta' in datosFactura) {
      letraFactura = `letrafactura=${datosFactura.SerieVenta}`;
      numFactura = `numFactura=${datosFactura.NumFacVenta}`;
      factura = datosFactura.NumFacVenta;
      lfactura = datosFactura.SerieVenta;
    } else if ('FacturaNumero' in datosFactura) {
      letraFactura = `letrafactura=${datosFactura.FacturaSerie}`;
      numFactura = `numFactura=${datosFactura.FacturaNumero}`;
      factura = datosFactura.FacturaNumero;
      lfactura = datosFactura.FacturaSerie;
    } else {
      letraFactura = `letrafactura=${datosFactura.SerieFactura}`;
      numFactura = `numFactura=${datosFactura.NumFacturaId}`;
      factura = datosFactura.NumFacturaId;
      lfactura = datosFactura.SerieFactura;
    }
    return { letraFactura, numFactura, factura, lfactura };
  }

  createTokenTarjeta() {
    const currentToken = this.tokenManager.currentTokenValue;
    if (!currentToken || !currentToken.token) {
      return throwError('No hay token de sesión disponible');
    }
    return of({ token: currentToken.token });
  }

  printPDFTarjeta(base64: string, fileName: string = 'factura'): void {
    if (
      this.window.external &&
      typeof this.window.external.imprimirPDFBinario === 'function'
    ) {
      this.window.external.imprimirPDFBinario(base64, 'factura');
      //return window.btoa(base64);
    } else {
      const binaryData = atob(base64);
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i) & 0xff;
      }

      const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName + '.pdf';
      link.click();
      URL.revokeObjectURL(blobUrl);
    }
  }

  recuperarDesgloseIVAFactura(datosFactura) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      LetraFactura: datosFactura.LetraFactura,
      NumFactura: datosFactura.NumFactura,
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/RecuperarFacturaIva`, body)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  /**
   * Genera PDF de factura para devoluciones usando WebAPIImpresionTaquilla
   * @param facturaSerie - Serie de la factura (LetraFactura)
   * @param facturaNumero - Número de la factura (NumFactura)
   * @param mails - Opcional: emails para envío
   */
  generarPDFFacturaDevolucion(facturaSerie: string, facturaNumero: string, mails?: string) {
    const currentToken = this.tokenManager.getTaquillaToken();
    if (!currentToken) {
      return throwError('No hay token de sesión disponible');
    }

    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const idioma = this.translateService.getLocale();
    const idiomaParam = `idioma=${idioma}`;
    const usuarioId = `usuarioId=${this.turnoService.turnoValue.UsuarioId}`;
    const tpvIdParam = `tpvId=${this.turnoService.turnoValue.TpvId}`;
    const letraFactura = `letraFactura=${facturaSerie}`;
    const numFactura = `numFactura=${facturaNumero}`;
    
    const headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
      Authorization: `Bearer ${currentToken}`,
      'IAC-Connection-String': this.config.getConfig('chClaveEmpresa'),
    };

    let url = `${this.config.getConfig(
      'API_URL_TAQUILLA'
    )}/api/Factura/GenerarPDF?conexionId=${conexionId}&${idiomaParam}&${tpvIdParam}&${usuarioId}&${letraFactura}&${numFactura}`;

    if (mails) {
      url += `&envioEMail=1&${mails}`;
    }
    
    return this.http
      .get(url, { headers: headers, responseType: 'json' })
      .pipe(
        map((response: { datos: string; emailEnviado: number }) => {
          return response;
        }),
        tap((pdfBase64) => {
          if (!mails) {
            this.printPDFTarjeta(
              pdfBase64.datos,
              this.config.getConfig('chClaveEmpresa')
            );
          }
        })
      );
  }
  /*   pdfFacturaGestionar(datosFactura) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      LetraFactura: datosFactura.SerieVenta,
      NumFactura: datosFactura.NumFacVenta
    };
    return this.http.post(`${this.config.getConfig('API_URL')}api/FacturaPDF`, body).pipe(
      map((res: any) => {
        return res;
      })
    );
  } */

  recuperarFacturaRelacionAnular(datosFactura) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      LetraFactura: datosFactura.FacturaSerie,
      NumFactura: datosFactura.FacturaNumero,
    };
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/RecuperarFacturaRelacion`,
        body
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  recuperarFacturaRelacion(datosFactura) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      LetraFactura: datosFactura.SerieFactura,
      NumFactura: datosFactura.NumFacturaId,
    };
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/RecuperarFacturaRelacion`,
        body
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  buscarCliente(terms: Observable<any>) {
    return (
      terms
        .pipe(debounceTime(400))
        .pipe(distinctUntilChanged())
        //.pipe(switchMap(input => this.getClientes(input.nombre)));
        // .pipe(switchMap(input => this.obtenerClientes(input.nombre)));
        .pipe(
          switchMap((input) => {
            if (input && input.search_field && input.search_field.length > 2) {
              return this.obtenerClientes(input.search_field);
            } else {
              return [];
            }
          })
        )
    );
  }

  buscarClientes(query: string, validarBaja = '1') {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TPVId: '1',
      Filtro: query,
      ValidarBaja: validarBaja,
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GetClientesXFiltro`, body)
      .pipe(shareReplay(1))
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            return [];
          }

          let ResultadoBuscadorClientes = res.DatosResult.ListadoCliente;
          let respuesta = {
            ResultadoBuscadorClientes: ResultadoBuscadorClientes,
          };
          return respuesta;
        })
      );
  }

  buscarClienteXCodigo(Codigo) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      CodigoCliente: Codigo,
      ValidarBaja: '1',
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GetClientesXFiltro`, body)
      .pipe(shareReplay(1))
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            return [];
          }

          let ResultadoBuscadorClientes = res.DatosResult.ListadoCliente;
          let respuesta = {
            ResultadoBuscadorClientes: ResultadoBuscadorClientes,
          };
          return respuesta;
        })
      );
  }


  getClientes(texto) {
    return this.buscarClientes(texto);
  }

  getClientesAsync(texto) {
    return this.buscarClientes(texto).toPromise();
  }

  async obtenerClientes(texto) {
    //Cargamos la lista solo si no hay lista o cambiamos el texto de busqueda
    if (
      !this.listaClientes ||
      !texto.startsWith(this.textoBuscadorValue) ||
      this.textoBuscadorValue == ''
    ) {
      this.settextoBuscadorValue(texto);
      this.listaClientes = await this.getClientesAsync(texto);
    }
    var respuesta = JSON.parse(JSON.stringify(this.listaClientes));
    var filtrado = this.listaClientes.ResultadoBuscadorClientes || [];
    respuesta.ResultadoBuscadorClientes = filtrado.filter(
      (elemento) =>
        elemento.NombreCliente.toUpperCase().includes(texto.toUpperCase()) ||
        elemento.NombreClienteFiscal.toUpperCase().includes(
          texto.toUpperCase()
        ) ||
        elemento.Codigo.toUpperCase().includes(texto.toUpperCase()) ||
        elemento.PersonaCobro.toUpperCase().includes(texto.toUpperCase()) ||
        elemento.CIFoDNI.toUpperCase().includes(texto.toUpperCase()) ||
        elemento.CIFoDNIFiscal.toUpperCase().includes(texto.toUpperCase()) ||
        elemento.EMail.toUpperCase().includes(texto.toUpperCase()) ||
        elemento.Telefono.toUpperCase().includes(texto.toUpperCase())
    );
    return respuesta;
  }

  getPaises() {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
    };
    return this.http.post(
      `${this.config.getConfig('API_URL')}api/Configuracion/GetPaises`,
      body
    );
  }
}
